"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEidCodes = void 0;
const getEidCodes = (eidBase = '') => {
  return {
    NewExactMatch: `${eidBase}new_exact_match`,
    PremiumDomain: {
      AftermarketExactMatch: `${eidBase}domain_premium_exact`,
      RegistryExactMatch: `${eidBase}domain_registry_premium_exact`,
      BoostImpression: `${eidBase}premium_boost.impression`
    },
    SmartTld: {
      Default: `${eidBase}domain_smartdefault`
    },
    Domain: {
      Exact: `${eidBase}domain_exact`
    },
    ExactMatchCards: `${eidBase}exact_match_cards`,
    ExactMatch: `${eidBase}exact_match`,
    AuctionDomain: {
      ExactMatch: `${eidBase}domain_auction_exact`
    },
    LeaseNow: {
      Click: 'lto_modal_open.click',
      Impression: 'lto',
      CheckoutAtDan: 'lto_goto_dan.click',
      MoveSliderPosition: 'lto_slider.click',
      LearnMore: 'lto_learn_more.click',
      Premium: `${eidBase}new_exact_match.premium_lto_enabled.impression`,
      Auction: `${eidBase}new_exact_match.auction_lto_enabled.impression`,
      UpdateLease: `${eidBase}lto_modal.update_lease.click`,
      LeaseItNow: `${eidBase}lto_modal.lease_it_now.click`,
      ADD_TO_CART_FAILURE: `${eidBase}domain_exact.lease-to-own.addtocart_failure.impression`
    }
  };
};
exports.getEidCodes = getEidCodes;